import { FC } from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';
import { Driver } from '../../../../types/driver';
import TableMenuButton from '../TableMenuButton';
import { DriverFormDataProviderProps } from '../EditSideBar';
import PolicyRequired from '../../../../components/common/PolicyRequired';

/** 編集・削除ボタンのためのカラムを表示するのに必要なポリシー (いずれがあれば表示) */
const etcColumnRequiredPolicies = [4, 5] as const;

type Props = {
  drivers: Driver[];
  openEdit: (props: DriverFormDataProviderProps | null) => void;
  sidebarClose: () => void;
};
const DriversTable: FC<Props> = ({ drivers, openEdit, sidebarClose }) => {
  return (
    <table className={classNames(styles.table, 'rounded-corners')}>
      <thead>
        <tr className={styles.head}>
          <th className={classNames(styles.headCell, styles.driverName)}>
            名前
          </th>
          <th className={classNames(styles.headCell, styles.skillLevel)}>
            習熟度
          </th>
          <th className={classNames(styles.headCell, styles.driverLicense)}>
            免許種別
          </th>
          <th className={classNames(styles.headCell, styles.qualifications)}>
            資格
          </th>
          <PolicyRequired anyPolicy={etcColumnRequiredPolicies}>
            <th className={classNames(styles.headCell, styles.etc)}></th>
          </PolicyRequired>
        </tr>
      </thead>
      <tbody>
        {drivers.map((driver) => (
          <tr key={driver.userId}>
            <td className={styles.dataCell}>
              <div className={styles.driverNameText}>{driver.driverName}</div>
            </td>
            <td className={styles.dataCell}>
              <div className={styles.skillLevelText}>
                {driver.skillLevel ? driver.skillLevel.name : ''}
              </div>
            </td>
            <td className={styles.dataCell}>
              {driver.driverLicense ? driver.driverLicense.name : ''}
            </td>
            <td className={styles.dataCell}>
              {driver.carQualifications?.map((qualification) => (
                <span key={qualification.id} className={styles.qualification}>
                  {qualification.name}
                </span>
              ))}
            </td>
            <PolicyRequired anyPolicy={etcColumnRequiredPolicies}>
              <td
                className={classNames(
                  styles.dataCell,
                  styles.ellipsisContainer
                )}
              >
                <TableMenuButton
                  driver={driver}
                  openEdit={openEdit}
                  sidebarClose={sidebarClose}
                />
              </td>
            </PolicyRequired>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default DriversTable;
